module.exports = __webpack_public_path__ + "static/media/exit-bunker.8ac9818b.png";